import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "page-icon",
  viewBox: "0 0 24 24",
  role: "img"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.5 18.75a2.75 2.75 0 0 1-2.75 2.75h-12A2.75 2.75 0 0 1 3 18.75v-14A2.75 2.75 0 0 1 5.75 2h9.172c.73 0 1.429.29 1.944.806l2.828 2.828a2.75 2.75 0 0 1 .806 1.944V18.75Zm-16-14c0-.69.56-1.25 1.25-1.25H14v3.25c0 .966.784 1.75 1.75 1.75H19v10.25c0 .69-.56 1.25-1.25 1.25h-12c-.69 0-1.25-.56-1.25-1.25v-14ZM18.858 7H15.75a.25.25 0 0 1-.25-.25V3.642c.112.058.215.134.306.224l2.828 2.828c.09.091.166.194.224.306Z"
    }, null, -1)
  ])))
}
export default { render: render }